import jQuery from 'jquery';
import AOS from 'aos';
import 'slick-carousel/slick/slick.min.js';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Import all of Bootstrap’s JS
import * as bootstrap from 'bootstrap';


jQuery(function ($) {
    "use strict";

    document.querySelectorAll('.dropdown-toggle').forEach(el => {
        const dropdown = new bootstrap.Dropdown(el);

        el.addEventListener('click', function (e) {
            e.preventDefault();
            dropdown.toggle();
        });
    });

    // Fade in content on page load - REQUIRED or content will not display
    const pageLoadTimeout = setTimeout(function () {
        $('body').addClass('delayfade');
    }, 300);


    // Navbar search functionality
    const searchInput = $('header .search-form-wrap input.search-input');

    searchInput.on('focus', function (e) {
        $(this).closest('.search-form-wrap').addClass('searching');
    }).on('focusout', function (e) {
        if ($(this).val() == '') {
            $(this).closest('.search-form-wrap').removeClass('searching');
        }
    });

    $('.search-toggle').on('click', function(e) {
        e.preventDefault();
        const $btn = $(this);
        const $searchField = $('.search-field');
        const $navLogo = $('.header-logo-wrap');
        $searchField.toggleClass('show');
        $navLogo.toggleClass('show');
        $btn.toggleClass('open');
        if ($searchField.hasClass('show')) {
            $searchField.trigger('focus');
        } else {
            $searchField.trigger('blur');
        }
    });
    

    // Insert ['News', 'Support', 'Rebates'] into the header nav
    const headerNav = $('#main-menu');
    const navItems = [
        { text: 'Contact', url: '/contact' },
        { text: 'Support', url: '/support' },
        { text: 'News', url: '/news' }
    ];
    navItems.forEach(item => {
        const navItem = $('<li class="menu-item menu-item-type-custom menu-item-object-custom"></li>');
        const navLink = $(`<a href="${item.url}">${item.text}</a>`);
        navItem.prepend(navLink);
        headerNav.prepend(navItem);
    });

    /****************************************************************/
    /**************************** SLIDERS ***************************/
    /****************************************************************/
    /* reference Slick Slider - https://kenwheeler.github.io/slick/ */

    function initiateSlider() {
        let $hrlSlider = $('.content-slider');

        if ($hrlSlider.length) {

            $hrlSlider.each(function () {

                // HERO SLIDER
                if ($(this).hasClass('slider-hero-full')) {

                    let hrlAppendDots = $(this).find('.dots-nav');
                    let hrlCustomPagingFunction = function () {
                        return $('<span></span>');
                    };

                    // animation callbacks to animate text inside slides
                    $(this).find('.hrl-slider-init')
                        .on('init', function (event, slick, currentSlide, nextSlide) {
                            $(this).find('.slick-active .hrl-animate-trigger').addClass('hrl-animate');
                        })
                        .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                            $(this).find('.slick-active .hrl-animate-trigger').removeClass('hrl-animate');
                        })
                        .on('afterChange', function (event, slick, currentSlide, nextSlide) {
                            $(this).find('.slick-active .hrl-animate-trigger').addClass('hrl-animate');
                        });

                    // initialize slide
                    $(this).find('.hrl-slider-init').slick({
                        fade: true,
                        speed: 500,
                        cssEase: 'ease-in-out',
                        arrows: false,
                        autoplay: true,
                        autoplaySpeed: 7000,
                        dots: true,
                        infinite: true,
                        appendDots: hrlAppendDots,
                        customPaging: hrlCustomPagingFunction
                    });
                }

            });
        }
    }

    initiateSlider();
    /************************** END SLIDERS *************************/


    // animate on scroll init - https://michalsnik.github.io/aos/
    // must init after any slick sliders
    AOS.init({
        offset: 200,
        disable: window.innerWidth < 768,
    });


    /*****************************************************************/
    /********************* LOCATION FUNCTIONALITY ********************/
    /*****************************************************************/
    const $btnLocationTrigger = $('header .state-selector-wrap #btnLocationTrigger');
    const $locationModelEl = $('#locationModal');
    const locationModal = bootstrap.Modal.getOrCreateInstance($locationModelEl[0]);
    const $stateSelector = $('#locationModal .states .state-col');
    const $noStateError = $('#locationModal .error-no-state');
    const cookieDaysToLive = 30;
    let selectedState = '';
    let triggeredNavigation = false; // tracks if selection caused a navigation so we avoid reload

    /*********************** COOKIE FUNCTIONS ************************/
    function setCookie(name, value, daysToLive) {
        // Encode value in order to escape semicolons, commas, and whitespace
        let cookie = name + "=" + encodeURIComponent(value);
        let secureAttr = '; secure';

        if (location.protocol !== 'https:') {
            secureAttr = '';
        }

        if (typeof daysToLive === "number") {
            // Set max-age attribute
            cookie += "; max-age=" + (daysToLive * 24 * 60 * 60) + "; path=/; SameSite=Strict" + secureAttr;

            document.cookie = cookie;
        }
    }

    function getCookie(name) {
        // Split cookie string and get all individual name=value pairs in an array
        let cookieArr = document.cookie.split(";");

        // Loop through the array elements
        for (let i = 0; i < cookieArr.length; i++) {
            let cookiePair = cookieArr[i].split("=");

            // Trim cookie name and compare
            if (name == cookiePair[0].trim()) {
                // Decode cookie and return
                return decodeURIComponent(cookiePair[1]);
            }
        }

        // Return null if not found
        return null;
    }

    // Check if cookie exists and trigger modal if not or setup data if so
    function checkCookie(name) {

        let cookieCheck = getCookie(name);

        if (cookieCheck === null || cookieCheck === '') {

            if ($('body.single-rebates').length) {

                setCookie("selectedState", $('main').data('rebateLocation'), cookieDaysToLive);
                setupDataPerState($('main').data('rebateLocation'));

            } else {

                locationModal.show();

            }

        } else {

            if ($('body.single-rebates').length) {

                setCookie("selectedState", $('main').data('rebateLocation'), cookieDaysToLive);
                setupDataPerState($('main').data('rebateLocation'));

            } else if( $('body.archive.tax-rebate_categories').length ) {

                setupDataPerState(cookieCheck);
                refreshRebates(cookieCheck);

            } else {

                setupDataPerState(cookieCheck);

            }

        }
    }
    /********************* END COOKIE FUNCTIONS **********************/

    // setup data per location cookie
    function setupDataPerState(state) {

        selectedState = state.toLowerCase();
        $btnLocationTrigger.find('.location-text').text(state);
        locationModal._config.backdrop = true;
        locationModal._config.keyboard = true;

        $stateSelector.each(function () {
            if ($(this).data('stateLocation') == selectedState) {
                $(this).addClass('selected-state');
            }
        });

        // update body class with current location for css hook
        $('body').removeClass(function (index, className) {

            return (className.match(/(^|\s)location-\S+/g) || []).join(' ');

        }).addClass('location-' + state);

        // Update the navbar location trigger so the icon updates accordingly.
        // Remove any previous location-* classes and add the new one.
        $btnLocationTrigger.removeClass(function(index, className) {
            return (className.match(/(^|\s)location-\S+/g) || []).join(' ');
        }).addClass('location-' + state.toLowerCase());

        // Set a data attribute on the trigger for easier CSS/hooks
        $btnLocationTrigger.attr('data-state', state.toLowerCase());

        // Try to pick up a state icon defined on the modal's state element via data-state-icon or data-stateIcon
        var $stateEl = $stateSelector.filter(function() {
            return $(this).data('statelocation') == selectedState || $(this).data('stateLocation') == selectedState;
        }).first();

        if ($stateEl.length) {
            var iconUrl = $stateEl.data('stateIcon') || $stateEl.data('state-icon') || null;

            if (iconUrl) {
                // If the trigger contains an <img class="state-icon">, update its src
                var $img = $btnLocationTrigger.find('img.state-icon');
                if ($img.length) {
                    $img.attr('src', iconUrl);
                } else {
                    // Otherwise, set a background-image on an element with class .state-icon if present
                    var $wrap = $btnLocationTrigger.find('.state-icon');
                    if ($wrap.length) {
                        $wrap.css('background-image', 'url("' + iconUrl + '")');
                    }
                }
            }
        }
    }

    // refresh rebates if user is on rebate archive page using ajax call
    function refreshRebates(state) {

        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php' + '?t=' + Date.now(),
            async: false,
            cache: false,
            dataType: 'html',
            data: {
                action: 'hrl_refresh_rebates',
                state: state,
                category: $('.rebates-wrap').data('category'),
            },
            success: function (res) {
                $('.rebates-wrap .row').html(res);
            },
            error: function (err) {
                console.error(err);
            }
        });

    }

    function stripParams(url) {
        return url.split('?')[0];
    }

    // Displays alert notification banners at bottom of page
    function displayAlertBanners() {
        $('.alert-banner').hide();

        var bodyClass = $('body').attr('class');
        var state = '';

        if (bodyClass.includes('location-idaho')) {
            state = 'idaho';
        } else if (bodyClass.includes('location-utah')) {
            state = 'utah';
        } else if (bodyClass.includes('location-wyoming')) {
            state = 'wyoming';
        }

        $.ajax({
            type: 'POST',
            url: ajax_object.ajaxurl,
            data: {
                action: 'check_alert_notifications',
                state: state,
                current_page_url: stripParams(window.location.href),
                nonce: ajax_object.nonce,
            },
            success: function(response) {
                if (response) {
                    $('body').append(response);
                }

                $('.close-banner').on("click", function() {
                    $('.alert-banner').hide();
                });
            }, error: function(err) {
                console.error(err);
            }
        });
    }

    // trigger location modal for user to select or change location
    $stateSelector.on("click", function (e) {
        const $curr = $(e.currentTarget);

        if (!$curr.hasClass('selected-state')) {
            $stateSelector.removeClass('selected-state');
            $curr.addClass('selected-state');
            selectedState = $curr.data('stateLocation');
            $noStateError.addClass('d-none');

            // Automatically apply selection and close modal
            // Reuse the confirm button logic to ensure cookies, UI updates, and any refresh actions run
            stateSelectedRefreshTasks();
        }
    });

    // confirm location selected from location modal
    function stateSelectedRefreshTasks() {

        // reset navigation flag for this selection
        triggeredNavigation = false;

        if (selectedState != '') {
            let prevState = $('#btnLocationTrigger .location-text').text().toLowerCase();

            $btnLocationTrigger.find('.location-text').text(selectedState);
            setCookie("selectedState", selectedState, cookieDaysToLive);
            setupDataPerState(selectedState);

            // refresh rebates if on archive page using ajax function
            if ($('body.archive.tax-rebate_categories section.posts-wrap.rebates-wrap').length) {
                refreshRebates(selectedState);
            }

            // trigger backlink if on single rebate template and that link exists (otherwise navigate home)
            if ($('body.single-rebates').length) {

                if (prevState !== selectedState) {

                    if ($('.backlink-wrap a.arrow-link.back').length) {

                        triggeredNavigation = true;
                        $('.backlink-wrap a.arrow-link.back')[0].click();

                    } else {

                        let slug = $('.main-content-wrap').data('catslug');
                        triggeredNavigation = true;
                        document.location.href = '/' + 'rebate-categories/' + slug;

                    }
                }
            }

            locationModal.hide();

            // Ensure any leftover backdrop or modal-open class is removed (safety cleanup)
            setTimeout(function() {
                $('.modal-backdrop').remove();
                $('body').removeClass('modal-open');

                // If we didn't already navigate away, reload the page so content reflects the new state
                if (!triggeredNavigation) {
                    location.reload();
                }
            }, 10);

        } else {

            $noStateError.removeClass('d-none');

        }

        // update result count for search page
        if ($('body.search').length) {
            countSearchItems();
        }

        displayAlertBanners();

    }

    // CHECK IF STATE HAS BEEN SELECTED & SETUP ACCORDINGLY
    checkCookie('selectedState');

    /********************** END LOCATION FUNCTIONALITY *********************/



    /***********************************************************************/
    /************************ LOCATION FUNCTIONALITY ***********************/
    /***********************************************************************/
    function countSearchItems() {
        let itemCount;
        const $searchResultNumber = $('#search-result-number');

        itemCount = $('.search-item.std-item').length;

        if ($('body.location-utah').length) {
            itemCount += $('.search-item.location-utah').length;
        }

        if ($('body.location-idaho').length) {
            itemCount += $('.search-item.location-idaho').length;
        }

        if ($('body.location-wyoming').length) {
            itemCount += $('.search-item.location-wyoming').length;
        }

        $searchResultNumber.text(itemCount);
    }

    if ($('body.search').length) {

        countSearchItems();
    }
    /*********************** END SEARCH FUNCTIONALITY **********************/


    // Prevent text widows on targetted elements
    //https://matmartin.co.uk/blog/code-prevent-widows-and-orphans-web-layouts/
    $('.no-orphans, .no-child-orphans p').each(function () {
        let string = $(this).html();
        string = string.replace(/ ([^ ]*)$/, '&nbsp;$1');
        $(this).html(string);
    });

    displayAlertBanners();

    /***********************************************************************/
    /************************ LOAD POSTS ***********************************/
    /***********************************************************************/

    $('.cat-nav').on('click', function(e) {
        if ($(window).width() <= 767) {
        $(this).toggleClass('show-dropdown');
        }
    });

    $(document).on('click', function(e) {
        var container = $('.cat-nav');
        if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass('show-dropdown');
        }
    });

    function loadPosts(categorySlug = '', paged = 1, scrollToTop = false) {
        $('#loader').show();
        $('#posts-container').addClass('loading');
        if (scrollToTop) {
            $('html, body').animate({
                scrollTop: $("#top").offset().top
            }, 500);
        }

        $.ajax({
            url: ajax_object.ajaxurl,
            type: 'POST',
            data: {
                'action': 'load_posts_by_category',
                'category_slug': categorySlug,
                'paged': paged,
                'nonce': ajax_object.nonce,
            },
            success: function(response){
                // Always hide loader / loading state regardless of response
                $('#loader').hide();
                $('#posts-container').removeClass('loading');

                var replaced = false;

                // If the server returned JSON (object) with success/data, use it
                try {
                    var parsed = (typeof response === 'string') ? JSON.parse(response) : response;
                    if (parsed && parsed.success && parsed.data && (parsed.data.content || parsed.data.pagination !== undefined)) {
                        $('#posts-container').html(parsed.data.content || '');
                        $('.ajax-pagination').html(parsed.data.pagination || '');
                        replaced = true;

                        // Update URL and active category as before
                        var newURL = window.location.origin + window.location.pathname;
                        if (categorySlug) {
                            newURL += '?category=' + categorySlug;
                        }
                        if (paged > 1) {
                            newURL += (categorySlug ? '&' : '?') + 'paged=' + paged;
                        }
                        window.history.pushState({ path: newURL }, '', newURL);

                        $('.category-link').removeClass('active');
                        if (categorySlug === '' || categorySlug === 'all') {
                            $('.category-link[data-category="all"]').addClass('active');
                        } else {
                            $('.category-link[data-category="' + categorySlug + '"]').addClass('active');
                        }
                    }
                } catch (err) {
                    // Not JSON - ignore here and handle as possible raw HTML below
                }

                // If not replaced yet, and response looks like HTML, use it
                if (!replaced) {
                    if (typeof response === 'string' && response.trim().length && response.trim().indexOf('<') !== -1) {
                        $('#posts-container').html(response);
                        $('.ajax-pagination').html('');
                        replaced = true;
                    } else {
                        // No usable content returned; keep server-rendered content in place
                        console.warn('loadPosts: no usable content returned, leaving existing posts in place', response);
                        $('.ajax-pagination').html('');
                    }
                }

                // Re-bind the pagination links to the AJAX function
                $('.ajax-pagination a').on('click', function(e) {
                    e.preventDefault();
                    var paged = $(this).attr('href').split('paged=')[1];
                    loadPosts(categorySlug, paged);
                });
            },
            error: function(err) {
                console.error(err);
                // Hide loader and remove loading class on error so UI isn't blocked
                $('#loader').hide();
                $('#posts-container').removeClass('loading');
            }
        });
    }

    // Get the category slug and pagination page from URL on initial page load
    var urlParams = new URLSearchParams(window.location.search);
    var categorySlug = urlParams.get('category') || '';
    var paged = urlParams.get('paged') || 1;

    $('.category-link').on('click', function(e){
        e.preventDefault();
        $('.category-link').removeClass('active');
        $(this).addClass('active');
        var categorySlug = $(this).data('category');
        loadPosts(categorySlug, 1, true);
    });

    // Load the first page with AJAX pagination by default
    // loadPosts(categorySlug, paged);

    /***********************************************************************/
    /************************ SELF AUDIT LINK ******************************/
    /***********************************************************************/

    const submitBtn = $('#customerID-submit');

    submitBtn.on('click', get_assessment_link);

    function extractUrl(text) {
        var urlRegex = /(https?:\/\/[a-zA-Z0-9\-._~:\/?#[\]@!$&'()*+,;=%]+)/g;
        var url = text.match(urlRegex);
        return url ? url[0] : null;
    }

    function get_assessment_link() {

        let customerID = $('#customerID').val();

        jQuery.ajax({
            url: ajax_object.ajaxurl,
            type : 'post',
            data : {
                action : 'techsee_api_get_audit_link',
                customerID : customerID,
            },

            success: function( response ) {
                const techseeLink = extractUrl(response.sessionLink);
                const tableWrap = $('#response-wrap');
                const table = $(`<table><tr><th>Customer ID</th><td>${response.customerID}</td></tr><tr><th>Assessment Link</th><td><a href="${techseeLink}">${techseeLink}</a></td><tr/>`);

                tableWrap.empty();
                tableWrap.append(table);
            }
        });
    }

    if ($('body.single-rebates').length) {
        $('a[href="https://wattsmarthomes.capturesportal.com/Public/tradeallysearch/findatradeally"]').attr('href', '/find-a-contractor');
    }


    /***********************************************************************/
    /************************ SINGLE REBATES *******************************/

    // when clicking on a .tabs-header without the active class, make that the active tab
    const $customerTab = $('.tabs-header.customer-header');
    const $applicationTab = $('.tabs-header.application-details-header');
    const $tradeAlliesTab = $('.tabs-header.trade-allies-header');
    const $customerContent = $('.tab-content.customer-content');
    const $applicationContent = $('.tab-content.application-details-content');
    const $tradeAlliesContent = $('.tab-content.trade-allies-content');

    $customerTab.on('click', (e)=> {
        $applicationTab.removeClass('active');
        $tradeAlliesTab.removeClass('active');
        $customerTab.addClass('active');
        $applicationContent.removeClass('active');
        $tradeAlliesContent.removeClass('active');
        $customerContent.addClass('active');
    });

    $applicationTab.on('click', (e)=> {
        $customerTab.removeClass('active');
        $tradeAlliesTab.removeClass('active');
        $applicationTab.addClass('active');
        $customerContent.removeClass('active');
        $tradeAlliesContent.removeClass('active');
        $applicationContent.addClass('active');
    });

    $tradeAlliesTab.on('click', (e)=> {
        $customerTab.removeClass('active');
        $applicationTab.removeClass('active');
        $tradeAlliesTab.addClass('active');
        $customerContent.removeClass('active');
        $applicationContent.removeClass('active');
        $tradeAlliesContent.addClass('active');
    });

});